import {  Modal, Image } from 'react-bootstrap';

export default function ImageModal(props) {
  return (
    <Modal
      {...props}
      size="md"
      centered
      backdropClassName="white-backdrop"
    >
      <Modal.Body className="modal-image">
        <Image 
          className="card" 
          src={props.src} 
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src=`images/cards/unknown.jpg`;
          }}
          loading="lazy"/>
      </Modal.Body>
    </Modal>
  );
}